<template>
  <div class="container page lottery">
    <van-nav-bar class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" @click="back()" />
      </template>
      <template #title>
        <div class="nav-title" @click="toggleGameList">
          <span>{{ lottery.name || $t("foorter.video") }}</span>
          <van-icon
            name="arrow-down"
            :class="{ up: title_arrow_active, down: !title_arrow_active }"
          />
        </div>
      </template>
      <template #right>
        <div class="right" @click="$router.push({ path: '/GameRecord' })">
          {{ $t("my.task_record") }}
        </div>
      </template>
    </van-nav-bar>

    <div
      class="zk-nav-list"
      v-if="title_arrow_active"
      @click.self="title_arrow_active = false"
    >
      <ul class="list-submenu">
        <li
          v-for="(i, index) in gameitemData"
          :key="index"
          @click="check_game(i)"
        >
          <span :class="{ activeSpan: keys == i.key || ids == i.id }">
            {{ i.name }}
          </span>
        </li>
      </ul>
    </div>

    <div class="record">
      <div class="period">
        <span class="period-number">{{ displayExpect }}</span>
        <div class="next-number">
          <van-count-down
            v-if="time !== null && time !== undefined"
            :key="countdownKey"
            :time="time"
            @finish="check()"
          />
        </div>
      </div>
      <div class="recent" @click="active = !active">
        <div class="kuaisan-ball left">
          <span class="res-des middle">{{ size || "-" }}</span>
          <span class="res-des middle">{{ double || "-" }}</span>
        </div>
        <van-icon
          name="arrow-down"
          :class="{ up: active, down: !active }"
        />
      </div>
    </div>

    <div class="history-panel" v-if="active">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="history-table">
          <div class="item head">
            <div class="col col-expect font-weight">
              {{ $t("reservation.num") }}
            </div>
            <div class="col col-r font-weight">
              {{ $t("reservation.win_num") }}
            </div>
            <div class="col col-r font-weight">
              {{ $t("reservation.win_num1") }}
            </div>
          </div>
          <div
            class="item"
            v-for="(v, key) in lottery_list"
            :key="key"
          >
            <div class="col col-expect font-weight">
              {{ formatExpect(v.expect) }}
            </div>
            <div class="col col-r font-weight">
              {{ historyOne(v) }}
            </div>
            <div class="col col-r font-weight">
              {{ historyTwo(v) }}
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <div class="wrapper" v-show="!active">
      <div class="options-bar">
        <div class="game">
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
              <div class="bet-card">
                <p
                  class="name-text large"
                  :class="{ active: !!choose[v.type] }"
                >
                  {{ playLabel(v.name || v.type) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mids">
        <div>
          <span>{{ formData.length }} {{ $t("zise.jian") }}</span>
          <span>
            {{ (formData.length * (Number(money) || 0)) | numfix }}
            {{ $t("zise.zongfen") }}
          </span>
        </div>
        <div class="mids-right">
          <span class="text">
            {{ $t("zise.zhanghuyuer") }}：{{
              iseye ? userInfo.money : "*****"
            }}
          </span>
          <van-icon
            v-if="iseye"
            name="eye"
            size="15"
            @click="iseye = false"
          />
          <van-icon
            v-else
            name="closed-eye"
            size="15"
            @click="iseye = true"
          />
          <span>{{ $t("zise.eyes") }}</span>
        </div>
      </div>

      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div class="reset-btn" @click="allClear">
              {{ $t("zise.chongzhi") }}
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <input
              class="pls"
              type="number"
              inputmode="numeric"
              v-model="money"
              :placeholder="$t('reservation.price_place')"
            />
          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("zise.baochou") }}
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="jiesuanpage" get-container="body" round>
      <div class="confirm-order-modal">
        <ul class="list">
          <li
            v-for="(v, key) in formData"
            :key="key"
            class="lise-item van-hairline--bottom"
          >
            <div class="main">
              <p class="bet-name">{{ playLabel(v.name || v.type) }}</p>
              <p class="detail-text">
                1{{ $t("reservation.note") }}×{{ money
                }}{{ $t("reservation.unit") }}={{ money
                }}{{ $t("reservation.unit") }}
              </p>
            </div>
            <van-icon name="close" @click="clearChooes(v.type)" />
          </li>
        </ul>
        <div class="sub-bar">
          <van-button class="item cancel-btn" type="default" @click="allClear()">
            {{ $t("reservation.clear_order") }}
          </van-button>
          <van-button class="item sub-btn" type="default" @click="doSub">
            {{ $t("reservation.submit") }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      title_arrow_active: false,
      iseye: true,
      rose: "",
      lily: "",
      balloon: "",
      fireworks: "",
      choose: {},
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: null,
      shopchoose: "",
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      userTimer: "",
      // 本期内锁定的展示期号，避免倒计时未结束时被接口提前刷新
      lockedExpect: "",
      countdownKey: 0,
      isRolling: false,
    };
  },
  filters: {
    numFix(v) {
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    },
  },
  computed: {
    displayExpect() {
      if (this.lockedExpect) return this.lockedExpect;
      return this.formatExpect(
        this.lottery.next_expect || this.lottery.now_expect || ""
      );
    },
  },
  mounted() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = "";
    }
    this.userTimer = setInterval(() => {
      this.getUserInfo();
    }, 10000);
  },
  methods: {
    back() {
      return window.history.back();
    },
    formatExpect(e) {
      if (!e && e !== 0) return "";
      const s = String(e);
      if (/^20\d{2}/.test(s)) return s;
      return String(this.seoulNow().year) + s;
    },
    // 统一用韩国时区，避免北京/韩国手机显示不同期号
    seoulNow() {
      const fmt = new Intl.DateTimeFormat("en-US", {
        timeZone: "Asia/Seoul",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
      });
      const parts = fmt.formatToParts(new Date());
      const get = (type) => {
        const hit = parts.find((p) => p.type === type);
        return hit ? parseInt(hit.value, 10) : 0;
      };
      return {
        year: get("year"),
        month: get("month"),
        day: get("day"),
        hour: get("hour"),
        minute: get("minute"),
        second: get("second"),
      };
    },
    // 与倒计时同一时钟：展示/投注期号 = 当前周期的下一期（韩国时间）
    computeBetExpect() {
      const ruleMin = parseInt((this.lottery && this.lottery.rule) || 0, 10) || 0;
      if (!ruleMin) {
        return this.formatExpect(
          (this.lottery && (this.lottery.next_expect || this.lottery.now_expect)) ||
            ""
        );
      }
      const periodSec = ruleMin * 60;
      const now = this.seoulNow();
      const fromMidnight =
        now.hour * 3600 + now.minute * 60 + now.second;
      const periodsPerDay = Math.floor(86400 / periodSec) || 1;
      let cur = Math.floor(fromMidnight / periodSec);
      let bet = cur + 1;
      let y = now.year;
      let m = now.month;
      let d = now.day;
      if (bet >= periodsPerDay) {
        bet = 0;
        const dt = new Date(Date.UTC(y, m - 1, d));
        dt.setUTCDate(dt.getUTCDate() + 1);
        y = dt.getUTCFullYear();
        m = dt.getUTCMonth() + 1;
        d = dt.getUTCDate();
      }
      const md =
        String(m).padStart(2, "0") + String(d).padStart(2, "0");
      return `${y}${md}${ruleMin}${bet}`;
    },
    // 在指定期号基础上 +1（倒计时结束时强制进下一期）
    advanceExpect(expectStr, ruleMin) {
      const s = String(expectStr || "");
      const rule = String(ruleMin);
      if (!s || !ruleMin) return this.computeBetExpect();
      // Ymd + rule + period
      const prefixLen = 8 + rule.length;
      if (s.length <= prefixLen) return this.computeBetExpect();
      const ymd = s.slice(0, 8);
      const period = parseInt(s.slice(prefixLen), 10);
      if (isNaN(period)) return this.computeBetExpect();
      const periodSec = ruleMin * 60;
      const periodsPerDay = Math.floor(86400 / periodSec) || 1;
      let next = period + 1;
      let y = parseInt(ymd.slice(0, 4), 10);
      let m = parseInt(ymd.slice(4, 6), 10);
      let d = parseInt(ymd.slice(6, 8), 10);
      if (next >= periodsPerDay) {
        next = 0;
        const dt = new Date(y, m - 1, d);
        dt.setDate(dt.getDate() + 1);
        y = dt.getFullYear();
        m = dt.getMonth() + 1;
        d = dt.getDate();
      }
      const md =
        String(m).padStart(2, "0") + String(d).padStart(2, "0");
      return `${y}${md}${ruleMin}${next}`;
    },
    // 倒计时结束：本地无缝换期，不先清空倒计时/期号
    rollToNextPeriod() {
      const ruleMin = parseInt((this.lottery && this.lottery.rule) || 0, 10) || 0;
      const periodSec = ruleMin > 0 ? ruleMin * 60 : 0;
      let next = this.computeBetExpect();
      if (this.lockedExpect && next === this.lockedExpect) {
        next = this.advanceExpect(this.lockedExpect, ruleMin);
      }
      this.lockedExpect = next;
      this._countdownExpect = next;
      let ms = this.calcRemainMs(this.lottery);
      if (ms == null || ms < 1500) {
        ms = (periodSec > 0 ? periodSec : 60) * 1000;
      }
      this.countdownKey += 1;
      this.time = ms;
    },
    historyOne(row) {
      if (!row) return "-";
      if (row.one) return this.playLabel(row.one);
      const nums = this.parseOpencode(row.opencode);
      if (!nums) return "-";
      const sum = nums[0] + nums[1] + nums[2];
      return this.playLabel(sum >= 11 && sum <= 18 ? "big" : "small");
    },
    historyTwo(row) {
      if (!row) return "-";
      if (row.two) return this.playLabel(row.two);
      const nums = this.parseOpencode(row.opencode);
      if (!nums) return "-";
      const sum = nums[0] + nums[1] + nums[2];
      return this.playLabel(sum % 2 === 0 ? "two" : "one");
    },
    playLabel(name) {
      if (name === undefined || name === null || name === "") return "";
      const raw = String(name).trim();
      const key = raw.toLowerCase();
      const dict = {
        big: "reservation.big",
        small: "reservation.small",
        one: "reservation.one",
        two: "reservation.two",
        single: "reservation.one",
        double: "reservation.two",
        a: "reservation.big",
        b: "reservation.small",
        c: "reservation.one",
        d: "reservation.two",
        大: "reservation.big",
        小: "reservation.small",
        单: "reservation.one",
        双: "reservation.two",
        玫瑰: "reservation.big",
        百合: "reservation.small",
        煙花: "reservation.one",
        烟花: "reservation.one",
        氣球: "reservation.two",
        气球: "reservation.two",
        장미: "reservation.big",
        백합: "reservation.small",
        불꽃놀이: "reservation.one",
        풍선: "reservation.two",
        청순한: "reservation.big",
        섹시한: "reservation.small",
        귀여운: "reservation.one",
        패티쉬: "reservation.two",
        rose: "reservation.big",
        lily: "reservation.small",
        fireworks: "reservation.one",
        balloon: "reservation.two",
      };
      if (dict[key] || dict[raw]) {
        return this.$t(dict[key] || dict[raw]);
      }
      return raw;
    },
    parseOpencode(raw) {
      if (!raw && raw !== 0) return null;
      let arr = raw;
      if (typeof raw === "string") {
        if (raw.indexOf(",") > -1) {
          arr = raw.split(",");
        } else if (/^\d{3}$/.test(raw)) {
          arr = [raw[0], raw[1], raw[2]];
        } else {
          return null;
        }
      }
      if (!Array.isArray(arr) || arr.length < 3) return null;
      const nums = arr.slice(0, 3).map((n) => parseInt(n, 10));
      if (nums.some((n) => isNaN(n))) return null;
      return nums;
    },
    applyOpenResult(raw, force) {
      const nums = this.parseOpencode(raw);
      if (!nums) return false;
      if (!force && this.size && this.double) return true;
      const sum = nums[0] + nums[1] + nums[2];
      this.sum = sum;
      if (sum >= 11 && sum <= 18) {
        this.size = this.playLabel("big");
      } else if (sum >= 3 && sum <= 10) {
        this.size = this.playLabel("small");
      } else {
        this.size = this.playLabel(sum >= 11 ? "big" : "small");
      }
      this.double = this.playLabel(sum % 2 === 0 ? "two" : "one");
      if (this.lottery && typeof this.lottery === "object") {
        this.$set(this.lottery, "one", this.size);
        this.$set(this.lottery, "two", this.double);
        this.$set(this.lottery, "opencode", nums);
      }
      return true;
    },
    normalizeList(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (typeof data === "object") return Object.keys(data).map((k) => data[k]);
      return [];
    },
    syncRecentResult() {
      if (this.lottery && this.lottery.opencode) {
        if (this.applyOpenResult(this.lottery.opencode, true)) return;
      }
      if (this.lottery && (this.lottery.one || this.lottery.two)) {
        if (this.lottery.one) this.size = this.playLabel(this.lottery.one);
        if (this.lottery.two) this.double = this.playLabel(this.lottery.two);
        if (this.size && this.double) return;
      }
      const list = this.normalizeList(this.lottery_list);
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (!item) continue;
        if (item.one || item.two) {
          if (item.one) this.size = this.playLabel(item.one);
          if (item.two) this.double = this.playLabel(item.two);
        }
        if (item.opencode && this.applyOpenResult(item.opencode, true)) {
          return;
        }
      }
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.displayExpect || this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      Object.keys(this.choose).forEach((k) => {
        this.$set(this.choose, k, false);
      });
      this.formData = [];
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    toggleGameList() {
      this.title_arrow_active = !this.title_arrow_active;
      if (this.title_arrow_active) this.getGameItem();
    },
    check_game(item) {
      if (!item) return;
      this.ids = item.id;
      this.keys = item.key;
      this.title_arrow_active = false;
      this.money = "";
      this.size = "";
      this.double = "";
      this.time = null;
      this.lockedExpect = "";
      this._countdownExpect = null;
      this.allClear();
      this.$toast.loading({ duration: 0, forbidClick: true });
      this.getUserInfo();
      this.getLotteryInfo().then(() => {
        this.$toast.clear();
      });
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage = !this.jiesuanpage;
      }
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.$set(this.choose, type, false);
          break;
        }
      }
      this.refreshChooseText();
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    refreshChooseText() {
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map((f) => f.name).join(",");
        this.gameitem = this.formData.map((f) => f.type).join(",");
        this.shopping = true;
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    choosePlay(type, name) {
      const label = this.playLabel(name || type);
      if (this.choose[type]) {
        this.$set(this.choose, type, false);
        this.formData = this.formData.filter((f) => f.type !== type);
      } else {
        this.formData.push({ name: label, type: type });
        this.$set(this.choose, type, true);
      }
      this.refreshChooseText();
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      if (this.isRolling) return;
      this.isRolling = true;
      // 先本地无缝换期（避免倒计时消失、期号闪成接口旧值）
      this.rollToNextPeriod();
      if (time) {
        clearInterval(time);
        time = null;
      }
      count = 0;
      time = window.setInterval(() => {
        this.getUserInfo();
        Promise.resolve(this.getLotteryInfo()).then(() => {
          // 只校准剩余时间，不改已锁定的新期号
          if (this.lottery) this.applyCountdown(this.lottery, false);
        });
        count++;
        if (count > 5) {
          clearInterval(time);
          time = null;
          count = 0;
          this.isRolling = false;
        }
      }, 300);
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (!res.data || !localStorage.getItem("token")) {
            this.$router.push({ path: "/Login" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data || [];
          (this.lottery_peilv_list || []).forEach((item) => {
            if (this.choose[item.type] === undefined) {
              this.$set(this.choose, item.type, false);
            }
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = this.normalizeList(res.data);
          this.syncRecentResult();
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitemData = this.normalizeList(res.data);
        // 若默认彩种与列表不一致，用列表第一项校正
        if (
          (!this.lottery || !this.lottery.name) &&
          this.gameitemData.length > 0
        ) {
          const hit =
            this.gameitemData.find(
              (g) => g.key == this.keys || g.id == this.ids
            ) || this.gameitemData[0];
          if (hit) {
            this.ids = hit.id;
            this.keys = hit.key;
          }
        }
      });
    },
    calcRemainMs(lottery) {
      if (!lottery) return null;
      const ruleMin = parseInt(lottery.rule, 10) || 0;
      const periodSec = ruleMin > 0 ? ruleMin * 60 : 0;
      const serverSec =
        lottery.second != null && lottery.second !== ""
          ? Number(lottery.second)
          : NaN;

      // 本地按韩国时区周期边界算剩余
      if (periodSec > 0) {
        const now = this.seoulNow();
        const fromMidnight =
          now.hour * 3600 + now.minute * 60 + now.second;
        let remain = periodSec - (fromMidnight % periodSec);
        if (remain <= 0) remain = periodSec;

        // 仅当服务端与本地接近时才采用（允许约 3 秒时钟误差）
        if (
          !isNaN(serverSec) &&
          serverSec > 0 &&
          serverSec <= periodSec &&
          Math.abs(serverSec - remain) <= 3
        ) {
          remain = serverSec;
        }
        return remain * 1000;
      }

      if (!isNaN(serverSec) && serverSec >= 0) {
        return serverSec * 1000;
      }
      return null;
    },
    applyCountdown(lottery, force) {
      const ms = this.calcRemainMs(lottery);
      if (ms == null) return;
      // 换期动画中：只校准剩余秒数，绝不回退/清空期号与倒计时
      if (this.isRolling && !force) {
        if (ms >= 1500) this.time = ms;
        return;
      }
      // 期号与倒计时绑定：本期内锁定，倒计时未结束不换期号
      if (force || !this.lockedExpect) {
        this.lockedExpect = this.computeBetExpect();
      }
      const expectKey = this.lockedExpect;
      if (force || this.time == null || this._countdownExpect !== expectKey) {
        this._countdownExpect = expectKey;
        this.countdownKey += 1;
        this.time = ms;
      } else if (Math.abs((this.time || 0) - ms) > 3000) {
        // 时钟偏差过大时静默校准，不闪断
        this.time = ms;
      }
    },
    getLotteryInfo() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (
            this.userInfo.money !== undefined &&
            res.data &&
            res.data.condition !== undefined &&
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data || {};
          if (this.lottery.key) this.keys = this.lottery.key;
          if (this.lottery.id) this.ids = this.lottery.id;

          // 未锁定时才用接口期号；已锁定则只校准倒计时，不换期号
          this.applyCountdown(res.data, !this.lockedExpect);

          this.syncRecentResult();
          return this.getLotteryList();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type == "type1") {
        if (zhi >= 11 && zhi <= 18) {
          return "d";
        } else {
          return "x";
        }
      }
      if (type == "type2") {
        if (zhi % 2 == 0) {
          return "v";
        } else {
          return "r";
        }
      }
      return "";
    },
  },
  created() {
    if (this.$route.query.id) this.ids = this.$route.query.id;
    if (this.$route.query.key) this.keys = this.$route.query.key;
    this.shopchoose = this.$t("reservation.no_choose");
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
    }
    const lang = localStorage.getItem("lang");
    if (lang == "zh") {
      this.rose = "玫瑰";
      this.lily = "百合";
      this.balloon = "氣球";
      this.fireworks = "煙花";
    } else if (lang == "en") {
      this.rose = "Rose";
      this.lily = "Lily";
      this.balloon = "Balloon";
      this.fireworks = "Fireworks";
    } else if (lang == "ja") {
      this.rose = "ロケット";
      this.lily = "ハート";
      this.balloon = "バラ";
      this.fireworks = "ヨット";
    } else {
      this.rose = "장미";
      this.lily = "백합";
      this.balloon = "풍선";
      this.fireworks = "불꽃놀이";
    }
  },
  destroyed() {
    clearInterval(time);
    if (this.userTimer) clearInterval(this.userTimer);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.lottery {
  background: #000000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 220px;
}

.nav-bar {
  background: #000 !important;
  border-bottom: 1px solid rgba(201, 168, 76, 0.45);
}
.nav-title {
  display: inline-flex;
  align-items: center;
  color: #c9a84c;
  font-size: 32px;
  font-weight: 700;
}
.nav-title .van-icon {
  margin-left: 8px;
  font-size: 28px;
  color: #c9a84c;
}
.nav-bar .right {
  padding: 0 12px;
  color: #c9a84c;
  font-size: 26px;
  border-radius: 10px;
  border: 2px solid rgba(201, 168, 76, 0.55);
  line-height: 56px;
  height: 56px;
}

.zk-nav-list {
  position: fixed;
  top: 92px;
  left: 0;
  width: 100%;
  height: calc(100% - 92px);
  background: #141414;
  z-index: 999999;
  overflow: auto;
}
.zk-nav-list .list-submenu {
  width: 100%;
  padding: 20px 0 40px;
  overflow: hidden;
  list-style: none;
  margin: 0;
}
.zk-nav-list .list-submenu li {
  float: left;
  width: 33.3%;
  text-align: center;
  margin-top: 12px;
}
.zk-nav-list .list-submenu li span {
  display: inline-block;
  width: 94%;
  height: 64px;
  line-height: 64px;
  border-radius: 8px;
  color: #c9a84c;
  background: #141414;
  border: 1px solid rgba(201, 168, 76, 0.45);
  font-size: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
  box-sizing: border-box;
}
.zk-nav-list .list-submenu li .activeSpan {
  border: 1px solid #c9a84c;
  background: #c9a84c;
  color: #000;
}

.record {
  padding: 0 20px;
  background: #141414;
  border-bottom: 1px solid rgba(201, 168, 76, 0.35);
  z-index: 1;
}
.record .period {
  display: flex;
  align-items: center;
  padding: 16px 0;
}
.record .period .period-number {
  flex: 1;
  height: 50px;
  line-height: 50px;
  font-size: 32px;
  font-weight: 700;
  color: #c9a84c;
}
.next-number {
  width: 200px;
  text-align: right;
}
.van-count-down {
  color: #c9a84c !important;
  font-size: 32px;
  float: none;
  border: none;
  padding: 0;
  margin: 0;
}

.record .recent {
  display: flex;
  align-items: center;
  height: 90px;
  background: #141414;
  padding: 0 4px 10px 0;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.kuaisan-ball.left {
  justify-content: flex-start;
}
.record .recent .res-des.middle,
.kuaisan-ball .res-des.middle {
  display: inline-block !important;
  width: auto !important;
  min-width: 100px;
  font-size: 30px !important;
  font-weight: 700 !important;
  text-align: left;
  color: #c9a84c !important;
  margin-right: 32px;
  line-height: 1.2;
  opacity: 1 !important;
  visibility: visible !important;
}
.record .recent .van-icon {
  color: #c9a84c !important;
  font-size: 36px !important;
}
.down {
  transition: all 0.5s;
  color: #c9a84c;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
  color: #c9a84c;
}

.wrapper {
  position: relative;
  flex: 1;
  background: #000000;
  overflow: hidden;
}
.options-bar {
  display: flex;
  align-items: flex-start;
  min-height: 420px;
  padding-bottom: 20px;
}
.options-bar .game {
  flex: 1;
  overflow-y: auto;
}
.sumValueTwoSides {
  display: flex;
  padding: 24px 0;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
.rectangle.large {
  width: 50%;
  border-radius: 10px;
  overflow: hidden;
}
.bet-card {
  padding: 0 12px 16px;
}
.name-text.large {
  width: 100%;
  font-size: 30px;
  font-weight: 700;
  padding: 28px 0;
  text-align: center;
  border-radius: 10px;
  background: #141414;
  border: 1px solid rgba(201, 168, 76, 0.45);
  box-shadow: none;
  color: #c9a84c;
  margin: 0;
}
.name-text.large.active {
  background: #c9a84c !important;
  color: #000 !important;
}

.mids {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 210px;
  z-index: 20;
  padding: 16px 28px;
  background: #141414;
  border-top: 1px solid rgba(201, 168, 76, 0.45);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #c9a84c;
  font-size: 24px;
}
.mids-right {
  display: flex;
  align-items: center;
}
.mids-right .text {
  margin-right: 8px;
}
.mids-right .van-icon {
  margin: 0 6px;
  color: #c9a84c;
  font-size: 28px !important;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 110px;
  height: 100px;
  z-index: 20;
  background: #141414;
  border-top: 1px solid rgba(201, 168, 76, 0.45);
}
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 0 8px;
}
.bottom-bar .bar .left {
  color: #c9a84c;
  font-size: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 140px;
}
.bottom-bar .bar .left .reset-btn {
  margin-right: 10px;
}
.bottom-bar .bar .left .line {
  width: 2px;
  height: 48px;
  background: #dadada;
}
.bottom-bar .bar .mid {
  margin-left: 10px;
  flex: 1;
}
.pls {
  background: #000;
  border: 1px solid rgba(201, 168, 76, 0.45);
  outline: none;
  border-radius: 40px;
  color: #c9a84c;
  padding-left: 28px;
  width: 100%;
  height: 56px;
  font-size: 24px;
}
.pls::placeholder {
  color: rgba(201, 168, 76, 0.55);
}
.bottom-bar .bar .right {
  padding: 0 28px;
  margin: 0 20px;
  color: #000;
  background: #c9a84c;
  font-size: 30px;
  font-weight: 500;
  border-radius: 40px;
  height: 56px;
  line-height: 56px;
  white-space: nowrap;
}

.confirm-order-modal {
  width: 610px;
  max-height: 50vh;
  padding: 24px 20px 30px;
  background: #141414;
  border-radius: 16px;
  color: #c9a84c;
}
.confirm-order-modal .list {
  list-style: none;
  margin: 0;
  padding: 0 10px;
  max-height: 40vh;
  overflow-y: auto;
}
.confirm-order-modal .lise-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
}
.confirm-order-modal .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .bet-name {
  color: #ff253f;
  font-size: 32px;
  font-weight: 500;
  margin: 0 0 8px;
}
.confirm-order-modal .detail-text {
  font-size: 24px;
  color: #979799;
  margin: 0;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 24px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 72px;
  font-size: 28px;
  border-radius: 40px;
}
.confirm-order-modal .cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background: #141414;
}
.confirm-order-modal .sub-btn {
  background: #c9a84c !important;
  color: #000 !important;
  border: 0 !important;
}

.history-panel {
  flex: 1;
  background: #999;
  min-height: calc(100vh - 280px);
  overflow-y: auto;
  padding-bottom: 40px;
}
.history-table {
  width: 100%;
  padding: 10px 0 30px;
}
.history-table .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 0;
  color: #fff;
}
.history-table .item.head {
  padding-top: 20px;
  padding-bottom: 18px;
}
.history-table .col {
  text-align: center;
  font-size: 28px;
  color: #fff;
  line-height: 1.3;
}
.history-table .col-expect {
  width: 40%;
  font-size: 28px;
}
.history-table .col-r {
  flex: 1;
  font-size: 30px;
}
.font-weight {
  font-weight: 700 !important;
}
</style>
